
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deleteNoteComment",
      resolverType: "mutation",
      routePath: "/deleteNoteComment",
      httpMethod: "POST",
    });
  